import { createMuiTheme } from '@material-ui/core/styles';

const gMDarkBlue = "#0B0C11";
const gMOrange = "#FFAD02";
const gMWhite = "#FFFFFF";
const gMRed = "#E83A3A";
const gMButton = "#2FEAE1";

export default createMuiTheme({
    mixins: {
        toolbar: {
            minHeight: 56
        }
    },
    palette: {
        common: {
            gameMeetDarkBlue: `${gMDarkBlue}`,
            gameMeetOrange: `${gMOrange}`,
            gameMeetButton: `${gMButton}`,
            primary:"red"
        },
        primary: {
            main: `${gMDarkBlue}`
        },
        secondary: {
            main: `${gMOrange}`
        },
        error: {
            main: `${gMRed}`
        }
    },
    typography: {
        h5: {
          fontWeight:400
        },
        tab: {
            fontWeight:'300',
            fontSize:"12px",
        },
        listItemIcon: {
            fontWeight:'400',
            fontSize:"12px"
        }
    }
})